import { render, staticRenderFns } from "./AlertTooltipsContainer.vue?vue&type=template&id=84e82138&"
import script from "./AlertTooltipsContainer.vue?vue&type=script&lang=js&"
export * from "./AlertTooltipsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports